// The 12 soothing sounds (DESIGN.md › Sound sheet). Names, icons and rhythms are product data; the
// short notes are placeholder copy from the CI reference until the content team replaces them.
export type SoundId = 'shush' | 'white' | 'womb' | 'heart' | 'hair' | 'fan' | 'vacuum' | 'washer' | 'car' | 'rain' | 'ocean' | 'music';

export type SoundDef = {
  id: SoundId;
  name: string;
  icon: string;
  note: string;
  /** Seconds per "breath" of the Baby Button glow, in the sound's own rhythm. */
  breath: number;
};

export const SOUNDS: SoundDef[] = [
  { id: 'shush', name: 'Shush', icon: '/art/felt/shush-mark.svg', note: 'Close to the steady whoosh your baby heard in the womb.', breath: 1.9 },
  { id: 'white', name: 'White noise', icon: '/art/felt/sound-machine.webp', note: 'An even hiss that covers household noise.', breath: 4 },
  { id: 'womb', name: 'Womb', icon: '/art/felt/comfort-lamb.webp', note: 'A muffled rumble with a slow, quiet heartbeat.', breath: 60 / 62 },
  { id: 'heart', name: 'Heartbeat', icon: '/art/felt/sound-heartbeat.webp', note: 'A calm heartbeat at 70 beats a minute.', breath: 60 / 70 },
  { id: 'hair', name: 'Hair dryer', icon: '/art/felt/sound-hairdryer.webp', note: 'A steady hum many babies settle to.', breath: 4 },
  { id: 'fan', name: 'Fan', icon: '/art/felt/sound-fan.webp', note: 'Soft, low airflow.', breath: 4 },
  { id: 'vacuum', name: 'Vacuum', icon: '/art/felt/sound-vacuum.webp', note: 'A loud, even rumble for hard crying spells.', breath: 4 },
  { id: 'washer', name: 'Washer', icon: '/art/felt/sound-washer.webp', note: 'A slow tumble and a low swish.', breath: 2.4 },
  { id: 'car', name: 'Car ride', icon: '/art/felt/sound-car.webp', note: 'The low engine rumble of a night drive.', breath: 4 },
  { id: 'rain', name: 'Rain', icon: '/art/felt/sound-rain.webp', note: 'Light rain on a window.', breath: 4 },
  { id: 'ocean', name: 'Ocean', icon: '/art/felt/sound-ocean.webp', note: 'Slow waves, about six a minute.', breath: 9 },
  { id: 'music', name: 'Music box', icon: '/art/felt/sound-musicbox.webp', note: "Brahms' Lullaby on a music box.", breath: 3.3 },
];

export const soundById = (id: string): SoundDef => SOUNDS.find((s) => s.id === id) ?? SOUNDS[0]!;

export const TIMER_OPTIONS = [15, 30, 45, 60, 0] as const; // 0 = no timer
export type TimerMin = (typeof TIMER_OPTIONS)[number];
